import { paths } from '@components/app/routes';

export const getCloseCreditAccountUrl = (
    searchParams: URLSearchParams,
    pathname: string,
    additionalParams: string = '',
) => {
    const additionalSearchParams = new URLSearchParams(additionalParams);

    additionalSearchParams.forEach((value, key) => {
        searchParams.set(key, value);
    });

    const path = {
        pathname: `${paths.CLOSE_CREDIT_ACCOUNT_TRANSFER_FORM_PAGE.path}/${pathname}`,
        search: searchParams.toString(),
    };

    return path;
};

export const clean = (value: string) => value.replace(/\D/gi, '');
